export const renderErrorStyle = (isError) => {
  if (isError) {
    return { border: "1px solid #EC5E49" };
  } else {
    return { border: "1px solid #EDEDED" };
  }
};
